import { postRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function calculateNextTripRequest(template) {
	let url = tripTemplates.getNextTripPath();
	let nextTrip = await postRequest(url, {}, { template });
	return nextTrip;
}